import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGeneratePdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={37}
    height={36}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      width={36}
      height={36}
      rx={18}
      fill="#C80A0A"
      fillOpacity={0.1}
    />
    <rect
      x={1}
      y={0.5}
      width={35}
      height={35}
      rx={17.5}
      stroke="#C80A0A"
      strokeOpacity={0.2}
    />
    <g clipPath="url(#logo-generate-pdf_svg__a)">
      <path
        d="m22.5 10 3.333 3.333v11.334c0 .736-.656 1.333-1.466 1.333H12.632c-.81 0-1.466-.597-1.466-1.333V11.333c0-.736.656-1.333 1.466-1.333H22.5Zm-6.833 2.667c-.748.066-1.312.547-1.414 1.191-.07.554.087 1.093.436 1.528a27.339 27.339 0 0 0 1.893 1.755c-.01.352-.035.703-.076 1.053l-.01.108v.013c-1.717.786-2.754 1.904-2.656 3.478a.862.862 0 0 0 .097.393c.175.346.544.52 1.03.473.649-.11 1.19-.44 1.527-.924.569-.704.804-1.475.942-2.73.386-.149.77-.267 1.228-.392.793.442 1.64.803 2.526 1.078.376.156.832.242 1.292.234.61-.021 1.143-.384 1.329-.926.095-.553-.116-1.016-.518-1.295a2.518 2.518 0 0 0-1.06-.407 8.837 8.837 0 0 0-3.441.234 11.56 11.56 0 0 1-.736-.482c-.151-.118-.31-.244-.469-.374a13.236 13.236 0 0 0-.216-2.265 2.674 2.674 0 0 0-.424-1.067 1.605 1.605 0 0 0-1.28-.676Zm.689 6.842c-.124.716-.315 1.195-.663 1.627-.2.285-.503.47-.857.532-.029-.871.52-1.584 1.52-2.159Zm3.878-1.237a7.852 7.852 0 0 1 1.865.016c.226.032.444.116.626.24.09.062.13.15.117.232-.024.05-.185.159-.386.166a2.367 2.367 0 0 1-.927-.175c-.45-.141-.881-.3-1.295-.479Zm-4.535-4.608a.594.594 0 0 1 .419.24c.137.205.228.436.266.674.073.402.127.802.16 1.203-.38-.344-.75-.697-1.108-1.059a.994.994 0 0 1-.192-.723c.025-.157.206-.311.455-.335Z"
        fill="#C80A0A"
      />
    </g>
    <defs>
      <clipPath id="logo-generate-pdf_svg__a">
        <path fill="#fff" transform="translate(10.5 10)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoGeneratePdf;
